function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h240v240H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(22 27)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  strokeWidth: 3,
  d: "M54.122 49.333L99 4.456l44.878 44.877"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(29 85)",
  fill: "#E57373"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 49.08,
  cy: 14.246,
  rx: 14.28,
  ry: 14.246
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 88.68,
  cy: 21.43,
  rx: 14.28,
  ry: 14.246
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.52,
  cy: 38.23,
  rx: 9.52,
  ry: 9.498
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.4 50.282h1.2c7.953 0 14.4 6.447 14.4 14.4V85H0V64.682c0-7.953 6.447-14.4 14.4-14.4zm108 4.788h1.2c7.953 0 14.4 6.448 14.4 14.4V85h-30V69.47c0-7.952 6.447-14.4 14.4-14.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48 31.127h2.4c10.604 0 19.2 8.596 19.2 19.2V85H28.8V50.327c0-10.604 8.596-19.2 19.2-19.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.6 38.31H90c10.604 0 19.2 8.596 19.2 19.2V85H68.4V57.51c0-10.604 8.596-19.2 19.2-19.2z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 123.52,
  cy: 43.019,
  rx: 9.52,
  ry: 9.498
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 49.5v136h193v-136H1.5zm17 17h161v103h-161v-103z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  cx: 98.433,
  cy: 5.7,
  r: 5.1
})), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(27 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(47 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(57 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(67 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(77 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(87 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(97 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(107 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(117 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(127 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(137 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(147 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(157 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(167 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(177 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(187 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(197 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(207 212)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
}))));

function SvgFamilyXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFamilyXl;